import React, { useEffect, useState } from "react";
import { Badge, Col, Form, Offcanvas, Row, Table } from "react-bootstrap";
import ManIconHighlighted from "../../../../../img/man-highlighted.png";
import ManIconInitiate from "../../../../../img/man-initiate.png";
import ManIconRed from "../../../../../img/manred.png";
import WomanIconHighlighted from "../../../../../img/woman-avatar-highlighted.png";
import WomanIconInitiate from "../../../../../img/woman-avatar.png";
import WomanIconRed from "../../../../../img/womanred.png";
import UnknownIconHighlighted from "../../../../../img/UnknownHighlight.png";
import UnknownIconInitiate from "../../../../../img/unknown.png";
import UnknownIconRed from "../../../../../img/unknownred.png";
import { studySubjectManagementServices } from "../../../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { useParams } from "react-router";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { eiwrsRandomizationSchemaServices } from "../../../../../APIServices/EIWRS/eiwrsRandomizationSchemaServices";
import Pagination from "../../../../Pagination";
import { eiwrsKitMetadataServices } from "../../../../../APIServices/EIWRS/KitManagement/eiwrsKitMetadataServices";
import { studyTreatmentManagementServices } from "../../../../../APIServices/CTMS/studyTreatmentManagementServices";

const ViewSubjectDetails = ({ Show, Hide, Title, siteId, subjectId, subjectDetails, tableRef, onMouseDown }) => {
  const [subjectRow, setSubjectRow] = useState("");
  const [loader, setLoader] = useState(false);
  const [factors, setFactors] = useState([]);
  const [dispenseKit, setDispenseKit] = useState([]);
  const [dispenseKitCount, setDispenseKitCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [treatmentColumns, setTreatmentColumns] = useState([]);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  let { studyId } = useParams()
  const getStudySingleSubjectRow = async () => {
    setLoader(true)
    let data = await studySubjectManagementServices.getStudySingleSubjectRow(studyId, siteId, subjectId)
    setSubjectRow(data?.data?.row);
    setFactors(data?.data?.factors || [])
    setLoader(false)
  }

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(dispenseKitCount / itemsPerPage);

  const getAssignedStudySubjectRandomizationKit = async () => {
    setLoading(true)
    let data = await eiwrsRandomizationSchemaServices.getAssignedStudySubjectRandomizationKit(studyId, siteId, subjectId, StudyMode, "", pageNumber, itemsPerPage)
    setDispenseKit(data?.data || [])
    setDispenseKitCount(data?.count || 0)
    setLoading(false)
  }

  const getEIWRSKitMetadataData = async (e) => {
    let data = await eiwrsKitMetadataServices.getEIWRSKitMetadataData(
      "active",
      studyId,
    );
    setColumns(data?.data || []);
  };

  const getStudyTreatmentColumnData = async (e) => {
    let data = await studyTreatmentManagementServices.getStudyTreatmentColumnData(
      "active",
      studyId
    );
    setTreatmentColumns(data?.data || []);
  };

  useEffect(() => {
    getEIWRSKitMetadataData();
    getStudyTreatmentColumnData();
  }, []);

  useEffect(() => {
    if (siteId && subjectId) {
      getStudySingleSubjectRow();
      getAssignedStudySubjectRandomizationKit();
    }
  }, [siteId, subjectId]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 850 }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="text-center mb-2">
            <img
              src={
                subjectDetails?.screeningStatus === "fail" ||
                  subjectDetails?.criteriaFailed
                  ? (subjectDetails?.subjectGender)?.toLowerCase() === "male"
                    ? ManIconRed
                    : (subjectDetails?.subjectGender)?.toLowerCase() === "female"
                      ? WomanIconRed
                      : UnknownIconRed
                  : subjectDetails?.subjectStatus === "completed"
                    ? (subjectDetails?.subjectGender)?.toLowerCase() === "male"
                      ? ManIconHighlighted
                      : (subjectDetails?.subjectGender)?.toLowerCase() === "female"
                        ? WomanIconHighlighted
                        : UnknownIconHighlighted
                    : (subjectDetails?.subjectGender)?.toLowerCase() === "male"
                      ? ManIconInitiate
                      : (subjectDetails?.subjectGender)?.toLowerCase() === "female"
                        ? WomanIconInitiate
                        : UnknownIconInitiate
              }
              alt=""
              style={{ width: 70, height: 70 }}
            />
          </div>
          <div className="text-center">
            <Badge
              bg={
                subjectDetails?.screeningStatus === "fail" ||
                  subjectDetails?.criteriaFailed
                  ? "danger-subtle"
                  : subjectDetails?.subjectStatus === "completed"
                    ? "success-subtle"
                    : "primary-subtle"
              }
              className="br3 text-dark"
              style={{ fontSize: 10 }}
            >
              {subjectDetails?.subjectName}
            </Badge>
          </div>
          <hr />
          {loader ? (
            <PageLoader />
          ) : (
            <Row>
              {subjectRow?.SCREENID &&
                <Col sm={12} md={12} lg={6} className="hstack gap-2">
                  <Form.Label className="fw-bold">Screen Id : </Form.Label>
                  <Form.Label>{subjectRow?.SCREENID}</Form.Label>
                </Col>
              }
              {subjectRow?.RANDOMNUMBER &&
                <Col sm={12} md={12} lg={6} className="hstack gap-2">
                  <Form.Label className="fw-bold">Random No. : </Form.Label>
                  <Form.Label>{subjectRow?.RANDOMNUMBER}</Form.Label>
                </Col>
              }
              {subjectRow?.SUBJECTID &&
                <Col sm={12} md={12} lg={6} className="hstack gap-2">
                  <Form.Label className="fw-bold">Subject Id : </Form.Label>
                  <Form.Label>{subjectRow?.SUBJECTID}</Form.Label>
                </Col>
              }
              {subjectRow?.SCREENINGDATE &&
                <Col sm={12} md={12} lg={6} className="hstack gap-2">
                  <Form.Label className="fw-bold">Screening Date : </Form.Label>
                  <Form.Label className="text-capitalize">
                    {subjectRow?.SCREENINGDATE}
                  </Form.Label>
                </Col>
              }
              {subjectRow?.GENDER &&
                <Col sm={12} md={12} lg={6} className="hstack gap-2">
                  <Form.Label className="fw-bold">Subject Gender : </Form.Label>
                  <Form.Label className="text-capitalize">
                    {subjectRow?.GENDER}
                  </Form.Label>
                </Col>
              }
              {subjectRow?.BOD &&
                <Col sm={12} md={12} lg={6} className="hstack gap-2">
                  <Form.Label className="fw-bold">Subject Date of Birth : </Form.Label>
                  <Form.Label className="text-capitalize">
                    {subjectRow?.BOD}
                  </Form.Label>
                </Col>
              }
              {subjectRow?.RANDOMIZATIONNUMBERMANUAL &&
                <Col sm={12} md={12} lg={6} className="hstack gap-2">
                  <Form.Label className="fw-bold">Randomization No (Manual) : </Form.Label>
                  <Form.Label className="text-capitalize">
                    {subjectRow?.RANDOMIZATIONNUMBERMANUAL}
                  </Form.Label>
                </Col>
              }
              {subjectRow?.SCREENINGNUMBERMANUAL &&
                <Col sm={12} md={12} lg={6} className="hstack gap-2">
                  <Form.Label className="fw-bold">Screening No (Manual) : </Form.Label>
                  <Form.Label className="text-capitalize">
                    {subjectRow?.SCREENINGNUMBERMANUAL}
                  </Form.Label>
                </Col>
              }
              <Col sm={12} md={12} lg={6} className="hstack gap-2">
                <Form.Label className="fw-bold">Subject Status : </Form.Label>
                <Form.Label className="text-capitalize">
                  {subjectDetails?.subjectStatus || "NA"}
                </Form.Label>
              </Col>
              <Col sm={12} md={12} lg={6} className="hstack gap-2">
                <Form.Label className="fw-bold">Screening Status : </Form.Label>
                <Form.Label className="text-capitalize">
                  {subjectDetails?.screeningStatus || "NA"}
                </Form.Label>
              </Col>
              {factors?.map((item, index) => (
                <Col sm={12} md={12} lg={6} key={index} className="hstack gap-2">
                  <Form.Label className="fw-bold">{item?.name} : </Form.Label>
                  <Form.Label className="text-capitalize">
                    {item?.value || "NA"}
                  </Form.Label>
                </Col>
              ))}
            </Row>
          )}
          {loading ?
            <div><PageLoader /></div>
            : dispenseKitCount === 0 ? (
              <div className={`hstack justify-content-center align-items-center`}>
                <Form.Label className="fw-bold p-2 text-center">Study Kit not found!</Form.Label>
              </div>
            )
              :
              <>
                <Form.Label className="fw-bold">Kit Number : </Form.Label>
                <Table ref={tableRef} className="m-0 custom-table" hover striped>
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        Sr.
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 1)}>
                        EventId
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 2)}>
                        Time Point Id
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 3)}>
                        Kit Number
                      </th>
                      {columns?.filter(column => column?.isUnique === "yes")?.map((item, index) => (
                        <th onMouseDown={(e) => onMouseDown(e, 4 + index)}>
                          {item?.columnLabel}
                        </th>
                      ))}
                      {treatmentColumns?.map((item, index) => (
                        <th onMouseDown={(e) => onMouseDown(e, columns?.length + 4 + index)}>
                          {item?.columnLabel}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {dispenseKit?.map((kitData, index) => (
                      <tr
                        key={index}
                        title="View Details"
                      >
                        <td
                          className="text-center"
                        >
                          {index + 1 + startIndex}.
                        </td>
                        <td>{kitData?.eventName}</td>
                        <td>{kitData?.timePointId || "_"}</td>
                        <td>{kitData?.kitNumber}</td>
                        {columns?.filter(column => column?.isUnique === "yes")?.map(item => {
                          const columnData = (kitData?.columns || [])?.find(
                            (ele) => ele?.columnName === item?.columnName
                          );
                          return (
                            <td
                              key={item?.columnId || item?.columnName}
                            >
                              {columnData?.columnValue || ""}
                            </td>
                          );
                        })}
                        {treatmentColumns?.map(item => {
                          return (
                            <td
                              key={item?.columnId || item?.columnName}
                            >
                              {kitData?.treatmentData[item?.columnName] || ""}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={setDispenseKitCount}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </>
          }
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ViewSubjectDetails;
